<template>
  <div class="nk-body body-wider bg-theme">
    <div class="nk-wrap">
      <header class="nk-header page-header is-transparent is-sticky is-dark" id="header">
        <div class="header-main">
          <HeaderMain />
        </div>
        <div class="banner banner-fs tc-light">
          <div class="nk-block nk-block-header my-auto">
            <div class="container container-xxl"> 
              <div class="row align-items-center justify-content-center justify-content-lg-between gutter-vr-30px">
                <div class="col-lg-6 order-lg-last">
                  <div class="banner-gfx banner-gfx-auto animated" data-animate="fadeInUp" data-delay=".7"> 
                    <img src="/static/images/custom/stamp-sample.png" alt="header">
                  </div>
                </div>
                <div class="col-xl-5 col-lg-6 col-sm-10 text-center text-lg-left">
                  <div class="banner-caption">
                    <h1 class="title title-lg ttu animated" data-animate="fadeInUp" data-delay=".8" id="buy">NEXT GENERATION STAMP SYSTEM</h1>   
                    <p class="lead animated" data-animate="fadeInUp" data-delay=".9">
                      NIPOST ESTAMP is an electronic stamp that can be used for Postal purposes, Philately, Document verification and denotion of receipts and instruments.
                    </p>
                    <p class="lead animated" data-animate="fadeInUp" data-delay="1">
                      <a href="https://play.google.com/store/apps/details?id=com.imaxinacion.nipost.qubit" target="_blank">
                        <img src="/static/images/custom/download-google.png" width="150" class="margBtms" alt="google-download">
                      </a> &nbsp; &nbsp; 
                      <a href="https://apps.apple.com/ng/app/nipost-qubit/id1477681785#?platform=iphone" target="_blank">
                        <img src="/static/images/custom/download-apple.png" class="margBtms" width="150" alt="apple-download">
                      </a> 
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="nk-block nk-block-status">
            <div class="container container-xxl">
              <div class="row gutter-vr-40px justify-content-between">
                <div class="col-xxl-6 col-xl-5 col-lg-5">
                  <div class="progress-wrap progress-wrap-point animated" data-animate="fadeInUp" data-delay="0.8">
                    <ul class="progress-info progress-info-s2">
                      <li>Applied Stamps - <span>{{isIssued}}</span></li>
                      <li class="text-right">Issued Stamps - <span>{{isSold}}</span></li>
                    </ul>
                    <div class="progress-bar progress-bar-xs">
                      <div class="progress-percent progress-percent-s2" data-percent="50"></div>
                      <div class="progress-point" data-point="25">Soft Cap</div>
                      <div class="progress-point" data-point="55">Crowdsale</div>
                      <div class="progress-point" data-point="85">Hard Cap</div>
                    </div>
                  </div>
                </div>
                <QuickVerification />
              </div>
            </div>
          </div>
          <div class="nk-block nk-block-actions">
            <div class="container container-xxl">
              <div class="row gutter-vr-40px align-items-center">
                <div class="col-sm-7 d-flex justify-content-center justify-content-sm-start">
                  <ul class="btn-grp btn-grp-break justify-content-center justify-content-sm-start gutter-vr-20px">
                    <li class="animated" data-animate="fadeInUp" data-delay="0.9">
                      <a href="" v-scroll-to="'#why'" class="link link-break">
                        <em class="icon-circle icon-border far fa-lightbulb"></em><span>Why NIPOST ESTAMPs?</span>           
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="col-sm-5">
                  <ul class="social-links social-links-s2 justify-content-center justify-content-sm-end animated" data-animate="fadeInUp" data-delay="1">
                    <li><a href="https://twitter.com/QuBitng" target="_blank">
                      <em class="fab fa-twitter"></em></a>
                    </li>          
                    <li><a href="https://www.instagram.com/QuBitng/" target="_blank">
                      <em class="fab fa-instagram"></em></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div id="particles-bg" class="particles-container is-fixed particles-bg op-20"></div>
        </div>
      </header>
      <main class="nk-pages tc-light">
        <AboutQubit />
        <PlatformFeatures />
        <WhyQubit />
        <Faqs />
        <Contact />
      </main>
      <Footer />
      <div class="nk-ovm nk-ovm-repeat nk-ovm-fixed shape-i">
        <div class="ovm-line"></div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderMain from '@/components/HeaderMain.vue'
import QuickVerification from '@/components/QuickVerification.vue'
import AboutQubit from '@/components/AboutQubit.vue'
import PlatformFeatures from '@/components/PlatformFeatures.vue'
import WhyQubit from '@/components/WhyQubit.vue'
import Faqs from '@/components/Faqs.vue'
import Contact from '@/components/Contact.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Home',
  components: {
    HeaderMain,
    QuickVerification,
    AboutQubit,
    PlatformFeatures,
    WhyQubit,
    Faqs,
    Contact,
    Footer
  },
  created () {
    this.$store.dispatch('loadSoldStamp')
  },
  computed: {
    isSold () {
      return this.$store.state.sold
    },
    isIssued () {
      return this.$store.state.issued
    }
  }
}
</script>

<style>

</style>
